module.exports = __webpack_public_path__ + "img/btn-FT.d48477b0.png";